window.Visualizations.Highcharts.MultipleBar = Object.assign({}, window.Visualizations.Highcharts.Base, {
  render: function (opts) {
    this.renderChart(opts.highchart_html_id, opts, {
      chart: {
        type: 'bar',
        height: 1900
      },
      xAxis: {
        categories: opts.categories
      },
      yAxis: {
        min: 0,
        title: {
          text: opts.y_title
        }
      },
      legend: {
        enabled: false
      },
      tooltip: {
        headerFormat: '<b>{point.x}</b><br/>',
        pointFormat: '{series.name}: {point.y}<br/>Total: {point.stackTotal}'
      },
      plotOptions: {
        bar: {
          stacking: false
        }
      },
      series: opts.series,
      colors: [
        '#009FE3',
        '#2C3F3C',
        '#A3C537',
        '#F09E02',
        '#6C145C',
        '#A54417',
        '#FDEEDC',
        '#277532',
        '#A31916',
        '#E6F5FE'
      ]
    });
  }
});
